module.exports = function setupDatabase(opts, router) {
    let db = null;

    if (opts.sqlite && !opts.db) {
        opts.db = { type: 'sqlite', url: opts.sqlite };
    }

    if (!opts.db) return db;

    const { type, url, options = {}, dbName } = opts.db;

    if (type === 'sqlite') {
        try {
            const { DatabaseSync } = require('node:sqlite');
            db = new DatabaseSync(url);
        } catch (e) {
            console.warn(`[!] Failed to load SQLite database: ${e.message}`);
            console.warn(`    If you are using Node < 22.5.0, node:sqlite might not be available.`);
        }
    } else if (type === 'postgres') {
        try {
            const { Pool } = require('pg');
            db = new Pool(Object.assign({ connectionString: url }, options));
        } catch (e) {
            if (e.code === 'MODULE_NOT_FOUND') {
                console.error('\n[x] Missing driver for PostgreSQL.');
                console.error('    Please install it by running: npm install pg\n');
                process.exit(1);
            }
            throw e;
        }
    } else if (type === 'mysql' || type === 'mariadb') {
        try {
            const mysql = require('mysql2/promise');
            db = mysql.createPool(Object.assign({ uri: url }, options));
        } catch (e) {
            if (e.code === 'MODULE_NOT_FOUND') {
                console.error(`\n[x] Missing driver for ${type}.`);
                console.error('    Please install it by running: npm install mysql2\n');
                process.exit(1);
            }
            throw e;
        }
    } else if (type === 'mongo') {
        try {
            const { MongoClient } = require('mongodb');
            const client = new MongoClient(url, options);
            client
                .connect()
                .then(() => {
                    console.log(`[fullstx] Connected to MongoDB (${dbName || 'default'})`);
                })
                .catch((err) => {
                    console.error(`[!] MongoDB connection error:`, err);
                });
            db = client.db(dbName);
        } catch (e) {
            if (e.code === 'MODULE_NOT_FOUND') {
                console.error('\n[x] Missing driver for MongoDB.');
                console.error('    Please install it by running: npm install mongodb\n');
                process.exit(1);
            }
            throw e;
        }
    } else if (type === 'redis') {
        try {
            const { createClient } = require('redis');
            db = createClient(Object.assign({ url }, options));
            db.on('error', (err) => console.error('[!] Redis Client Error', err));
            db.connect()
                .then(() => {
                    console.log(`[fullstx] Connected to Redis`);
                })
                .catch((err) => {
                    console.error(`[!] Redis connection error:`, err);
                });
        } catch (e) {
            if (e.code === 'MODULE_NOT_FOUND') {
                console.error('\n[x] Missing driver for Redis.');
                console.error('    Please install it by running: npm install redis\n');
                process.exit(1);
            }
            throw e;
        }
    } else if (type === 'chroma') {
        try {
            const { ChromaClient } = require('chromadb');
            db = new ChromaClient(Object.assign({ path: url }, options));
            console.log(`[fullstx] Initialized ChromaDB client`);
        } catch (e) {
            if (e.code === 'MODULE_NOT_FOUND') {
                console.error('\n[x] Missing driver for ChromaDB.');
                console.error('    Please install it by running: npm install chromadb\n');
                process.exit(1);
            }
            throw e;
        }
    } else if (type === 'firebase') {
        try {
            const admin = require('firebase-admin');
            const app = admin.initializeApp(options);
            db = app.firestore();
            console.log(`[fullstx] Initialized Firebase Firestore`);
        } catch (e) {
            if (e.code === 'MODULE_NOT_FOUND') {
                console.error('\n[x] Missing driver for Firebase.');
                console.error('    Please install it by running: npm install firebase-admin\n');
                process.exit(1);
            }
            throw e;
        }
    } else if (type === 'supabase') {
        try {
            const { createClient } = require('@supabase/supabase-js');
            db = createClient(url, options.key, options);
            console.log(`[fullstx] Initialized Supabase client`);
        } catch (e) {
            if (e.code === 'MODULE_NOT_FOUND') {
                console.error('\n[x] Missing driver for Supabase.');
                console.error('    Please install it by running: npm install @supabase/supabase-js\n');
                process.exit(1);
            }
            throw e;
        }
    } else if (type === 'elasticsearch' || type === 'elastic') {
        try {
            const { Client } = require('@elastic/elasticsearch');
            db = new Client(Object.assign({ node: url }, options));
            console.log(`[fullstx] Initialized Elasticsearch client`);
        } catch (e) {
            if (e.code === 'MODULE_NOT_FOUND') {
                console.error('\n[x] Missing driver for Elasticsearch.');
                console.error('    Please install it by running: npm install @elastic/elasticsearch\n');
                process.exit(1);
            }
            throw e;
        }
    } else {
        console.warn(`[!] Unsupported database type: ${type}`);
    }

    if (db) {
        router.use((req, res, next) => {
            req.db = db;
            next();
        });
    }

    return db;
};
